import React, { useEffect, useState } from "react";
import LayoutHeader from "../../inc/LayoutHeader";
import LayoutFooter from "../../inc/LayoutFooter";
import { Layout, Card, Table, Select, Button, Tag } from "antd";
import dayjs from "dayjs";

import { getAPI, postAPI } from "../../../utils/common";
import { ALL_VENDOR, VENDOR_LEDGER_REPORT } from "../../../constants/api";

const { Content } = Layout;

function VendorLedger() {
  const [vendors, setVendors] = useState([]);
  const [vendorId, setVendorId] = useState(null);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getAPI(ALL_VENDOR, (res) => {
      if (res.status) setVendors(res.data);
    });
  }, []);

  const loadLedger = () => {
    if (!vendorId) return;

    setLoading(true);
    postAPI(
      VENDOR_LEDGER_REPORT,
      { vendor_id: vendorId },
      (res) => {
        if (res.status) {
          const formatted = res.data.map((row, index) => ({
            key: index,
            Date: dayjs(row.date).format("DD MMM YYYY"),
            Type: row.type,
            Amount: (
              <Tag color={row.amount < 0 ? "green" : "red"}>
                ₹ {Math.abs(row.amount)}
              </Tag>
            ),
          }));
          setData(formatted);
        }
        setLoading(false);
      },
      () => setLoading(false)
    );
  };

  const columns = [
    { title: "Date", dataIndex: "Date", width: 150 },
    { title: "Type", dataIndex: "Type", width: 200 },
    { title: "Amount", dataIndex: "Amount", width: 150 },
  ];

  return (
    <Layout>
      <LayoutHeader />
      <Content>
        <Card
          title="Vendor Ledger"
          extra={
            <>
              <Select
                placeholder="Select Vendor"
                style={{ width: 250, marginRight: 10 }}
                onChange={(val) => setVendorId(val)}
              >
                {vendors.map((v) => (
                  <Select.Option key={v.id} value={v.id}>
                    {v.name}
                  </Select.Option>
                ))}
              </Select>
              <Button onClick={loadLedger} type="primary">
                View
              </Button>
            </>
          }
        >
          <Table
            loading={loading}
            columns={columns}
            dataSource={data}
            pagination={false}
          />
        </Card>
      </Content>
      <LayoutFooter />
    </Layout>
  );
}

export default VendorLedger;
